export default class PrepareBusStopList {
  constructor(priceList, flight) {
    this.priceList = priceList;
    this.flight = flight;
    return this;
  }

  buStoplist() {
    if (!this.priceList.bus_stops || !this.priceList.bus_stops[this.airportCode()]) {
      // no bus stops for this airport
      return [];
    }

    return this.priceList.bus_stops[this.airportCode()];
  }

  airportCode() {
    return this.flight.airport.code;
  }

}
